<div class="cooling-system-details-container">
  <app-system-status
    [systemStatus]="systemStatus"
    [isSystemStatusLoading]="isSystemStatusLoading"
  ></app-system-status>

  <sh-text class="coolingDataHeader" size="header-2">
    {{ 'cooling.dataHeader' | translate }}
  </sh-text>

  <div class="dateHeader" *ngIf="timezoneOffsetInHours">
    <sh-text size="body-2" class="timezoneOffset">
      {{ 'cooling.localSystemTimezone' | translate }}:
      {{ timezoneOffsetInHours }}
    </sh-text>
  </div>

  <!-- Base Graph Section (Index 0) -->
  <div class="graph-section" *ngIf="graphStateList[0] as baseGraphStatus">
    <app-cooling-date-picker
      class="date-picker-base"
      [dateFormat]="selectedDateFormat"
      [startDate]="baseGraphStatus.dateRange.startDate"
      [endDate]="baseGraphStatus.dateRange.endDate"
      [dateFilter]="rangeFilter"
      [pickerId]="'baseGraphDatePicker'"
      (dateChange)="onDateChange(0, $event)"
    ></app-cooling-date-picker>

    <div class="graph-section__content">
      <app-cooling-graph-display
        [status]="graphStateList[0]?.status"
        [config]="graphStateList[0]?.configList ?? null"
        [dateFormat]="selectedDateFormat"
      ></app-cooling-graph-display>
    </div>
  </div>

  <!-- Custom Graphs Section (Index > 0) -->
  <div
    class="custom-graph-cards"
    *ngFor="let graphState of graphStateList; let graphIndex = index"
    [hidden]="graphIndex === 0"
  >
    <sh-card class="custom-graph-card-body">
      <!-- ============================================ -->
      <!-- BEFORE SUBMIT: Configuration State -->
      <!-- ============================================ -->
      <ng-container *ngIf="graphState.status === 'idle'">
        <sh-text size="header-2">
          {{ 'cooling.graph.customGraphTitle' | translate }}
        </sh-text>

        <!-- Input Fields: Parameters & Date Range -->
        <div class="custom-graph-card-inputs-before-submit">
          <mat-form-field appearance="fill" class="mat-parameter-form-field">
            <mat-label>{{ 'cooling.graph.dataLabel' | translate }}</mat-label>
            <mat-select
              multiple
              [value]="graphStateList[graphIndex].parameterSelections"
              (selectionChange)="
                onParameterSelectionChange(graphIndex, $event.value)
              "
            >
              <mat-option
                *ngFor="let option of parameterOptions"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <app-cooling-date-picker
            class="date-picker-custom"
            [dateFormat]="selectedDateFormat"
            [startDate]="graphState.dateRange.startDate"
            [endDate]="graphState.dateRange.endDate"
            [dateFilter]="rangeFilter"
            [pickerId]="'customGraphDatePickerBeforeSubmit_' + graphIndex"
            (dateChange)="onDateChange(graphIndex, $event)"
          ></app-cooling-date-picker>
        </div>

        <!-- Action Buttons -->
        <div class="custom-graph-card-actions-before-submit">
          <sh-button
            label="{{ 'cooling.graph.cancel' | translate }}"
            color="secondary"
            size="max-content"
            (click)="removeGraph(graphIndex)"
          ></sh-button>
          <sh-button
            label="{{ 'cooling.graph.createGraph' | translate }}"
            color="primary"
            size="max-content"
            (click)="loadCustomGraph(graphIndex)"
            [disabled]="!canLoadGraph(graphIndex)"
          ></sh-button>
        </div>
      </ng-container>

      <!-- ============================================ -->
      <!-- AFTER SUBMIT: Loaded State -->
      <!-- ============================================ -->
      <ng-container *ngIf="!(graphState.status === 'idle')">
        <div class="custom-graph-card-header-with-action">
          <sh-text size="header-2">
            {{ graphState.parameterSelections.join(', ') }}
          </sh-text>

          <sh-button
            label="{{ 'cooling.graph.delete' | translate }}"
            color="secondary"
            icon="delete"
            icon-position="left"
            size="max-content"
            (click)="removeGraph(graphIndex)"
          ></sh-button>
        </div>

        <!-- Date Range Picker (Only Input Available) -->
        <div class="custom-graph-card-inputs">
          <app-cooling-date-picker
            class="date-picker-custom"
            [dateFormat]="selectedDateFormat"
            [startDate]="graphState.dateRange.startDate"
            [endDate]="graphState.dateRange.endDate"
            [dateFilter]="rangeFilter"
            [pickerId]="'customGraphDatePickerAfterSubmit_' + graphIndex"
            (dateChange)="onDateChange(graphIndex, $event)"
          ></app-cooling-date-picker>
        </div>

        <div class="custom-graph-card-content">
          <app-cooling-graph-display
            [status]="graphStateList[graphIndex]?.status"
            [config]="graphStateList[graphIndex]?.configList ?? null"
            [dateFormat]="selectedDateFormat"
          ></app-cooling-graph-display>
        </div>
      </ng-container>
    </sh-card>
  </div>

  <div class="add-date-range-button-wrapper">
    <sh-button
      color="secondary"
      size="max-content"
      class="add-date-range-button"
      label="{{ 'cooling.graph.addCustomGraph' | translate }}"
      (click)="addNewCustomGraph()"
    ></sh-button>
  </div>
</div>
